import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

import * as actions from '@catdetails/actions/project';

@Injectable()
export class ProjectDetailsService {
  private projectDetails$: Observable<any>;

  constructor(private store: Store<any>) {
    this.projectDetails$ = store.select((state) => state.projectDetails);
  }

  refresh(projectId: any) {
    this.store.dispatch({
      type: actions.PROJECT_DETAILS_REFRESH,
      payload: {id: projectId},
    });

  }

  loaded(projectId: any) {
    this.store.dispatch({
      type: actions.PROJECT_DETAILS_LOADED,
      payload: {id: projectId},
    });

  }

  unloaded() {
    this.store.dispatch({
      type: actions.PROJECT_DETAILS_UNLOAD,
    });

  }

  getProjectDetails() {
    return this.projectDetails$;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project-details/services/project-details.service.ts